import { useEffect, useRef, useState } from 'react';

// Fetches a CMS list endpoint. The fallback stays on screen until real data arrives,
// and stays for good if the API never answers - so a page is never blank.
export function useCmsList(path, fallback) {
  const [items, setItems] = useState(fallback);

  useEffect(() => {
    let alive = true;
    fetch(path)
      .then((r) => (r.ok ? r.json() : Promise.reject(new Error(String(r.status)))))
      .then((data) => {
        if (alive && Array.isArray(data) && data.length > 0) setItems(data);
      })
      .catch(() => {});
    return () => {
      alive = false;
    };
  }, [path]);

  return items;
}

// Same idea for endpoints that return a single object rather than a list.
export function useCmsDoc(path, fallback) {
  const [doc, setDoc] = useState(fallback);
  const fb = useRef(fallback);

  useEffect(() => {
    let alive = true;
    fetch(path)
      .then((r) => (r.ok ? r.json() : Promise.reject(new Error(String(r.status)))))
      .then((data) => {
        if (alive && data && typeof data === 'object' && !Array.isArray(data)) {
          setDoc({ ...fb.current, ...data });
        }
      })
      .catch(() => {});
    return () => {
      alive = false;
    };
  }, [path]);

  return doc;
}

// Shows a stored date in the reader's language. Anything unparseable is shown unchanged.
export function formatDate(value, language) {
  if (!value) return '';
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return value;
  return d.toLocaleDateString(language === 'en' ? 'en-US' : 'de-DE', {
    day: 'numeric',
    month: 'long',
    year: 'numeric',
  });
}
